import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const BrutalistPhilosophy = () => {
  const containerRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(textRef.current.children, {
        y: 50,
        opacity: 0,
        duration: 1,
        stagger: 0.2,
        scrollTrigger: {
          trigger: containerRef.current,
          start: 'top 70%',
        }
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={containerRef} className="py-32 px-6 bg-foreground text-background relative overflow-hidden">
      <div className="max-w-7xl mx-auto text-center md:text-left">
        <div ref={textRef} className="flex flex-col gap-4">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-sans font-bold uppercase tracking-tight leading-none text-white">
            Большинство складов продаёт квадратные метры.
          </h2>
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-serif italic text-accent leading-none">
            Мы управляем безопасностью.
          </h2>
        </div>
      </div>
      
      {/* Background Grid */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" 
        style={{ backgroundImage: 'radial-gradient(#333 1px, transparent 1px)', backgroundSize: '40px 40px' }} 
      />
    </section>
  );
};

export default BrutalistPhilosophy;
